import { forwardRef } from "react";

import { Checkbox } from "antd";

import { cn } from "@btnet/utilities-core";

import "./BuiCheckbox.less";
import { type IBuiCheckboxProps } from "./BuiCheckbox.types";

export const BuiCheckbox = forwardRef<HTMLInputElement, IBuiCheckboxProps>(
  (props, ref) => {
    const { children, id, "data-testid": testid, readOnly, disabled } = props;
    // The label element carries `${id}label` so consumers (e.g. BTCheckbox) can
    // point the input's aria-labelledby at it for an accessible name.
    const labelId = id !== undefined && id !== null ? `${id}label` : undefined;
    return (
      <Checkbox
        {...props}
        ref={ref}
        data-testid={testid}
        className={cn("bui-checkbox", props.className, {
          readOnly: readOnly,
          disabled: disabled,
        })}
      >
        <span className="bui-checkbox-content">
          <div className="icon icon-md" />
          <div
            id={labelId}
            data-testid={testid + "-label"}
            className="bui-checkbox-children"
          >
            {children}
          </div>
        </span>
      </Checkbox>
    );
  },
);

BuiCheckbox.displayName = "BuiCheckbox";
